import { useMutation } from "@tanstack/react-query";
import { getProposalsSdk } from "../graphql/client/proposals";
export const useCreateProposal = () => {
    return useMutation(["governance.getProposals"], async ({ proposal, proof }) => {
        // Artifical delay.
        await new Promise((res) => {
            setTimeout(res, 1000);
        });
        const { createProposal } = await getProposalsSdk();
        return await createProposal({
            proposal,
            proof,
        });
    });
};
//# sourceMappingURL=useCreateProposal.js.map